var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":"240px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-layout',{attrs:{"row":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":240,"color":"primary","indeterminate":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }